export const FEEDBACK_SURVEY_URL = 'https://4xu6wknl4ap.typeform.com/to/BocJcZMN';

export function feedbackSurveyUrl(userId: string | null | undefined): string {
  if (!userId) return FEEDBACK_SURVEY_URL;
  return `${FEEDBACK_SURVEY_URL}#user_id=${encodeURIComponent(userId)}`;
}
